export default class Configurator {
	constructor() {
		document.addEventListener('click', function (event) {
			if (!event.target.closest('.configurator__bullet')) return;

			const tooltip = event.target.closest('.configurator__info').querySelector('.configurator__tooltip');
			if (tooltip) {
				tooltip.classList.toggle('is--open');
			}
		});

		const tooltipCloseAll = document.querySelectorAll('.configurator__tooltip-close');
		tooltipCloseAll.forEach(tooltipClose => {
			tooltipClose.addEventListener('click', (event) => {
				const tooltip = event.target.closest('.configurator__tooltip');

				if (tooltip) {
					tooltip.classList.remove('is--open');
				}
			});
		});
	}
}